import { SurveysComponent } from './surveys/surveys.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EventsComponent } from '@app/event/events/events.component';
import { EventTypesComponent } from '@app/event/event-types/event-types.component';
import { CouponGroupsComponent } from '@app/event/coupon-groups/coupon-groups.component';
import { SignUpComponent } from '@app/event/sign-up/sign-up.component';
import { RegistrationComponent } from '@app/event/registration/registration.component';
import { EventScheduleComponent } from '@app/event/schedule/event-schedule.component'
import { MyRegistrationsComponent } from '@app/event/my-registrations/my-registrations.component';
import { RegistrationsComponent } from '@app/event/registrations/registrations.component';
import { CredentialsComponent } from '@app/event/credentials/credentials.component';
import { AnswerComponent } from './surveys/answer/answer.component';
import { ValidateCertificateComponent } from './certificate/validate/validate.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        children: [
          { path: 'signUp', component: SignUpComponent },
          { path: 'signUp/:token', component: SignUpComponent },
          { path: 'signUp/:onLocal', component: SignUpComponent },
          { path: 'signUp/:onLocal/:orderId/:success', component: SignUpComponent },
          { path: 'registration', component: RegistrationComponent },
          { path: 'registration/:token', component: RegistrationComponent },
          { path: 'schedule', component: EventScheduleComponent },
          { path: 'myRegistrations', component: MyRegistrationsComponent, data: { permission: 'Pages.Events.Registrations.Create' } },
          { path: 'registrations', component: RegistrationsComponent, data: { permission: 'Pages.Events.Registrations.Management' } },
          { path: 'events', component: EventsComponent, data: { permission: 'Pages.Events.Events.Management' } },
          { path: 'eventTypes', component: EventTypesComponent, data: { permission: 'Pages.Events.EventTypes' } },
          { path: 'couponGroups', component: CouponGroupsComponent, data: { permission: 'Pages.Events.Coupons' } },
          { path: 'credentials', component: CredentialsComponent, data: { permission: 'Pages.Events.Credentials' } },
          { path: 'surveys', component: SurveysComponent, data: { permission: 'Pages.Events.Surveys.Management' } },
          { path: 'answerSurvey/:surveyId/:registrationId/:userId', component: AnswerComponent },
          { path: 'validateCertificate/:registrationId/:userId', component: ValidateCertificateComponent }
        ]
      }
    ])
  ],
  exports: [
    RouterModule
  ]
})

export class EventRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/event/event-routing.module.ts